import { t } from "i18next";
import React from "react";

export default function HeadTabel({ children, customClass }) {
  return (
    <>
      <thead className={customClass}>
        {children}
        <tr className="text-center">
          <th>{t("Id")}</th>
          <th> {t("name")}</th>
          <th>{t("Reservations Date")}</th>
          <th> {t("Reservations")}</th>
        </tr>
      </thead>
    </>
  );
}
